import React, { useEffect, useState } from 'react';
import { MenuForm } from '../Menu.js';
import { SecurityElement } from '../elements/security_element.js';
import { useAPICall } from '../../hooks/useAPICall.js';

import { useNavigate } from 'react-router-dom';

import 'react-datepicker/dist/react-datepicker.css';
import { PageMenuElement } from '../elements/page_menu.js';


export function AdminReportsForm() {


    const [pageData, setPageData] = useState();
    const navigate = useNavigate();
    const { MakeCall } = useAPICall();


    const handleDataFetch = (data) => {
        setPageData(data);

    }
    useEffect(() => {
        MakeCall('reports/getreportdata', "{ \"token\" : \"" + sessionStorage.getItem("Token") + "\"}", handleDataFetch);
    });


 
    function handleNav(destination, state) {
        navigate(destination, state);
    }
   

   

    function onPageMenuClick(onclickname) {
        switch (onclickname) {
            case 'goback':
                handleNav("/Admin");
                break;
           
            default:
                break;
        }
    }

function handleShowSummary()
{
    handleNav("/ReportMembershipSummary");

}

function handleShowLapsed()
{
    handleNav("/ReportLapsedMembership");
}
function handleShowPending()
{
    handleNav("/ReportPendingMembership");
}
function handleShowCurrentRO()
{
    handleNav("/ReportCurrentROs");
}
function handleShowMemberVisits()
{
    handleNav("/ReportMemberVisits");
}

function handleShowVisitsByDate()
{
    handleNav("/ReportVisitsByDate");
}
    return (

        <div>

            {SecurityElement(pageData)}
            {MenuForm()}
            
            <div className="contentdiv">
            {PageMenuElement("Reports", [{ "name": "Back", "onclick": "goback" }], onPageMenuClick)}
              
                <div className='formbox'>
                    <div className='formtitle'>Reports</div>
                    <div className='formrow' key='summaryreport'>
                        <div className='formlabel' style={{"fontWeight" : "600", "width" : "30%"}}>Membership Summary</div>
                        <div className='formlabel' style={{"width" : "50%"}}>A report showing current membership numbers</div>                        
                        <div className='formlabel' > <button className='prcbtn' type='button' onClick={handleShowSummary}>View</button></div>                      
                    </div>                    
                    <div className='formrow' key='lapsedreport'>
                        <div className='formlabel' style={{"fontWeight" : "600", "width" : "30%"}}>Lapsed Members</div>
                        <div className='formlabel' style={{"width" : "50%"}}>A report showing memberships which lapsed in a given year</div>                        
                        <div className='formlabel' > <button className='prcbtn' type='button' onClick={handleShowLapsed}>View</button>  </div>                      
                    </div>
                    <div className='formrow' key='currentroreport'>
                        <div className='formlabel' style={{"fontWeight" : "600", "width" : "30%"}}>Current Range Officers</div>
                        <div className='formlabel' style={{"width" : "50%"}}>A report showing current range officers and the date they last recorded an RO visit</div>                        
                        <div className='formlabel' > <button className='prcbtn' type='button' onClick={handleShowCurrentRO}>View</button>  </div>                      
                    </div>
                    <div className='formrow' key='membervisitreport'>
                        <div className='formlabel' style={{"fontWeight" : "600", "width" : "30%"}}>Member Visits</div>
                        <div className='formlabel' style={{"width" : "50%"}}>A report showing member visit counts</div>                        
                        <div className='formlabel' > <button className='prcbtn' type='button' onClick={handleShowMemberVisits}>View</button>  </div>                      
                    </div>
                    <div className='formrow' key='membervisitsbydate'>
                        <div className='formlabel' style={{"fontWeight" : "600", "width" : "30%"}}>Visits By Date</div>
                        <div className='formlabel' style={{"width" : "50%"}}>A report showing member visits on a specific date</div>                        
                        <div className='formlabel' > <button className='prcbtn' type='button' onClick={handleShowVisitsByDate}>View</button>  </div>                      
                    </div>
                    <div className='formrow' key='membervisitsbydate'>
                        <div className='formlabel' style={{"fontWeight" : "600", "width" : "30%"}}>Pending Members</div>
                        <div className='formlabel' style={{"width" : "50%"}}>A report showing members who are currently Pending</div>                        
                        <div className='formlabel' > <button className='prcbtn' type='button' onClick={handleShowPending}>View</button>  </div>                      
                    </div>
                </div>

           
            </div>
        </div>


    );
}
